import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'items-per-page-selector',
  templateUrl: './itemsPerPage.component.html',
  imports: [CommonModule, TranslatePipe, FormsModule],
})
export class ItemsPerPageComponent {
  choices = [10, 25, 50];

  @Input()
  itemsPerPage: number = 25;

  @Output()
  public itemsPerPageChange = new EventEmitter<number>();

  onChangeItemsPerPage(newValue: number) {
    this.itemsPerPageChange.emit(newValue);
  }
}
